import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-window-line',
      title: 'Web Design Nashville',
      subtitle: 'Simple Business Websites',
      description:
        'Clean, modern websites designed specifically for Nashville small businesses. We build professional sites that rank in local search and turn visitors into customers.',
      features: ['Mobile-responsive design', 'Local SEO optimization', 'Fast load times'],
      link: '/portfolio',
      primaryKeyword: 'website design Nashville',
    },
    {
      icon: 'ri-server-line',
      title: 'Web Hosting Nashville',
      subtitle: 'Website Hosting & Management',
      description:
        'We host and manage your Nashville business website so you never deal with downtime, security issues, or server maintenance. Focus on your business — we handle the rest.',
      features: ['99.9% uptime guarantee', 'SSL security included', 'Daily backups'],
      link: '/portfolio#hosting',
      primaryKeyword: 'web hosting Nashville',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Website Management Nashville',
      subtitle: 'Website Updates & Maintenance',
      description:
        'Need to update your hours, services, photos, or pricing? Our Nashville website management team handles changes quickly so your site stays accurate and up to date.',
      features: ['Unlimited content updates', 'Priority turnaround', 'Monthly reports'],
      link: '/portfolio#hosting',
      primaryKeyword: 'website management Nashville',
    },
    {
      icon: 'ri-robot-line',
      title: 'AI Web Development Nashville',
      subtitle: 'Fast Website Launch',
      description:
        'Our AI-powered development process means Nashville businesses go live in days — not months. Get a professional website faster and more affordably than traditional agencies.',
      features: ['Preview in 24 hours', 'Live within days', 'AI-powered design'],
      link: '/portfolio#launch',
      primaryKeyword: 'AI web development Nashville',
    },
  ];

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-20 lg:py-32 bg-gradient-to-b from-black to-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-20">
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
            <span className="text-sm text-gray-300 font-medium">Nashville Web Development Services</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6">
            Web Development Services in Nashville, TN
          </h2>
          <p className="text-base sm:text-xl text-gray-400 max-w-3xl mx-auto">
            From <strong className="text-white">website design in Nashville</strong> to ongoing hosting and management — we provide everything a small business needs to succeed online, at a price that makes sense.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 mb-12 lg:mb-16">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="group bg-black border border-white/10 rounded-3xl p-6 sm:p-10 hover:border-white/30 hover:shadow-2xl hover:shadow-white/5 transition-all duration-300 cursor-pointer block"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl mb-5 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <div className="mb-2">
                <span className="text-xs uppercase tracking-widest text-gray-500">{service.primaryKeyword}</span>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-1">{service.title}</h3>
              <p className="text-sm text-gray-500 mb-4">{service.subtitle}</p>
              <p className="text-gray-400 leading-relaxed mb-6 text-sm sm:text-base">{service.description}</p>
              <ul className="space-y-2 mb-6">
                {service.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-gray-400">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border border-white/20 rounded-full ml-auto group-hover:bg-white group-hover:border-white transition-all duration-300">
                <i className="ri-arrow-right-line text-white group-hover:text-black transition-colors duration-300"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA Row */}
        <div className="text-center">
          <p className="text-gray-400 mb-6 text-base sm:text-lg">
            Ready to grow your Nashville business online?
          </p>
          <button
            onClick={scrollToContact}
            className="px-8 sm:px-10 py-4 bg-white text-black font-bold rounded-lg hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get a Free Demo Website
          </button>
        </div>
      </div>
    </section>
  );
}
